"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIELD_DISPLAY_NAME = 'displayName';
function getOrderParam(fieldName, ascending) {
    return {
        field: fieldName,
        ascending: ascending
    };
}
function getSearchUserOrderParams() {
    var isAscending = true;
    var displayNameOrderParam = getOrderParam(exports.FIELD_DISPLAY_NAME, isAscending);
    return [displayNameOrderParam];
}
exports.getSearchUserOrderParams = getSearchUserOrderParams;
//# sourceMappingURL=OrderParams.js.map